"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.preview.title': 'Detalles del Paquete de Precios',
    'accountGrade.preview.back': 'Volver a Paquetes de Precios',
    'accountGrade.preview.edit': 'Editar Paquete de Precios',
    'accountGrade.preview.delete': 'Eliminar Paquete de Precios',
    'accountGrade.preview.enabled': 'Habilitado',
    'accountGrade.preview.disabled': 'Deshabilitado',
    'accountGrade.preview.no_data': 'No hay datos de paquete de precios disponibles',
    'accountGrade.preview.error.load_failed': 'Error al cargar el paquete de precios para vista previa',
    'accountGrade.preview.unnamed': 'Paquete de Precios Sin Nombre',
    'accountGrade.preview.no_description': 'No se proporcionó descripción',
    'accountGrade.preview.price': 'Precio mensual',
    'accountGrade.preview.free': 'Gratis',
    'accountGrade.preview.cents': 'centavos',
};
